'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WonItems = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

var _wonLostCatalogsTransform = require('./wonLostCatalogsTransform');

var _wonLostCatalogsTransform2 = _interopRequireDefault(_wonLostCatalogsTransform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WonItems = exports.WonItems = {
    fetchWonItems: function fetchWonItems(_ref) {
        var authToken = _ref.authToken,
            bidderId = _ref.bidderId,
            catalogId = _ref.catalogId,
            deployment = _ref.deployment,
            _ref$page = _ref.page,
            page = _ref$page === undefined ? 1 : _ref$page,
            _ref$pageSize = _ref.pageSize,
            pageSize = _ref$pageSize === undefined ? 1250 : _ref$pageSize;

        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<MAINHOST-API>api/bidders/' + bidderId + '/wonitems', deployment);
            request.query({ client_version: '5.0', page: page, pagesize: pageSize });
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response, transform: _wonLostCatalogsTransform2.default });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/wonItems.js
// module id = 1Wc7
// module chunks = 57